import $ from 'jquery';
import blogPagination from './blog-pagination';

export default function blogList() {
  
  function filterPost() {

    const validFilter = ["all", "news", "project-management", "tech", "user-experience", "eventi", "innovazione", "case-study", "elearning", "hr", "cro-and-marketing"];

    $('.blog-list .blog-list__filter .btn-filter').on('click', function(e) {
			e.preventDefault();
      
      const category = $(this).data("filter");
      $('.blog-list .show-more').html(`<button class="show-more__btn show-more__btn--gradient" data-category=${category}>Mostra altri</button>`);

			$('.blog-list .blog-list__filter .btn-filter').removeClass("active");
			$(this).addClass('active');
      location.hash = category;
      
      if (category === 'all') {
        $('.blog-list .blog-list__post .box-post').removeClass('d-none');
      } else {
        $('.blog-list .blog-list__post .box-post').addClass('d-none');
        $(`.box-post[data-category='${category}']`).removeClass('d-none');
      }

      blogPagination();
		});

    if (window.location.hash) {
      const hash = window.location.hash.split('#')[1];

      if(validFilter.indexOf(hash) > -1) {
        $('.blog-list .blog-list__filter .btn-filter').removeClass("active");
        $(`.blog-list .blog-list__filter .btn-filter[data-filter='${hash}']`).addClass('active');
        
        if (hash === 'all') {
          $('.blog-list .blog-list__post .box-post').removeClass('d-none');
          $('.blog-list .show-more').html(`<button class="show-more__btn show-more__btn--gradient" data-category="all">Mostra altri</button>`);
        } else {
          $('.blog-list .blog-list__post .box-post').addClass('d-none');
          $(`.box-post[data-category='${hash}']`).removeClass('d-none');
          $('.blog-list .show-more').html(`<button class="show-more__btn show-more__btn--gradient" data-category=${hash}>Mostra altri</button>`);
        }
      }
    }
  }

  if($('.blog-list .blog-list__filter .btn-filter').length > 0) {
    filterPost();
  }
}